export enum Routes {
  BookingCreation = "/create-booking",
  HallSelection = "select-hall",
  TimeSelection = "select-time",
  EquipmentSelection = "select-equipment",
  BookingDetailPreview = "booking-details-preview",

  BookingCreationHallSelection = "/create-booking/select-hall",
  BookingCreationTimeSelection = "/create-booking/select-time",
  BookingCreationEquipmentSelection = "/create-booking/select-equipment",
  BookingCreationBookingDetailPreview = "/create-booking/booking-details-preview",

  BookingById = "/booking/:id",

  AboutCompany = "/about-company",
}
